import { render, staticRenderFns } from "./GLoadingButton.vue?vue&type=template&id=ff3d0e68&"
import script from "./GLoadingButton.vue?vue&type=script&lang=js&"
export * from "./GLoadingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports